<template>
  <div class="IriadeVimeoPlayerContainer">
    <iframe class="IriadeVimeoPlayer"
            style="border: 1px solid #ddd"
            :src="`${videoUrl}?title=false&byline=false&portrait=false&color=${$vuetify.theme.currentTheme.primary.substr(1)}`"
            allowfullscreen></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      videoUrl: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .IriadeVimeoPlayerContainer {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }

  .IriadeVimeoPlayer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
